import axios from 'axios'
import store from '../../store/index'

const state = {
  content: [],
}

const mutations = {
  content_data (state, content) {
    state.content = content
  },
  remove_content (state, appContentId) {
    let theIndex = null
    state.content.filter((item, index) => {
      if (item.appContentId === appContentId) {
        theIndex = index
      }
    })
    if (theIndex !== null) {
      state.content.splice(theIndex, 1)
    }
  },
  add_content (state, newContent) {
    state.content.push(newContent)
  },
}

const actions = {
  createContent ({ commit }, content) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/content',
        data: content,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteContent ({ commit }, appContentId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/content?appContentId=' + appContentId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getContentList ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/content/list',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('content_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getLocationContentList ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/content/list/?locationId=' + locationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getContentByAppContentId ({ commit }, appContentId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/content/?appContentId=' + appContentId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateContent ({ commit }, content) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/content/?appContentId=' + content.appContentId,
        data: content,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  duplicateContent ({ commit }, appContentId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/content/duplicate/?appContentId=' + appContentId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
